import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import ConfigurationAutomationProtocolsModalBasicForm
    from '@/modules/configurationModule/detail/automation/protocols/components/modal-basic-form/configuration-automation-protocols-modal-basic-form.vue'
import ConfigurationAutomationProtocolsModalProtocolsForm
    from '@/modules/configurationModule/detail/automation/protocols/components/modal-protocols-form/configuration-automation-protocols-modal-protocols-form.vue'
import { BModal } from 'bootstrap-vue'
import {
    ConfigurationAutomationProtocolsModalState, ConfigurationAutomationProtocolsModalTabIndex,
    initialConfigurationAutomationProtocolsModalState
} from '@/modules/configurationModule/detail/automation/protocols/components/modal/configuration-automation-protocols-modal.model'
import { ConfigurationAutomaticOntologyProtocolResponse } from '@/modules/configurationModule/detail/automation/protocols/services/configuration-automatic-ontology-protocol/configuration-automatic-ontology-protocol.dto'

@Component({
    components: {
        ConfigurationAutomationProtocolsModalBasicForm,
        ConfigurationAutomationProtocolsModalProtocolsForm
    }
})
export default class ConfigurationAutomationProtocolsModal extends Vue {
    @Ref() readonly automationProtocolsModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Emit()
    create(): void {}

    @Emit()
    update(): void {}

    @Emit()
    delete(): void {}

    state: ConfigurationAutomationProtocolsModalState
    constructor() {
        super()
        this.state = initialConfigurationAutomationProtocolsModalState()
    }

    get isProtocolsTabDisabled(): boolean {
        return !this.state.ontologyForAutomaticProtocol?.id && !this.state.showProtocolsTab
    }

    async show(ontologyForAutomaticProtocol?: ConfigurationAutomaticOntologyProtocolResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationAutomationProtocolsModalState()
        if (ontologyForAutomaticProtocol) {
            this.state.ontologyForAutomaticProtocol = ontologyForAutomaticProtocol
        }

        this.automationProtocolsModal.show()
    }

    hide(): void {
        this.automationProtocolsModal.hide()
    }

    onCreateOntologyForAutomaticProtocol() {
        this.state.showProtocolsTab = true

        // wait for the DOM update (when protocols tab is active)
        this.$nextTick(() => (this.state.activeTabIndex = ConfigurationAutomationProtocolsModalTabIndex.PROTOCOLS))
    }

    onUpdateOntologyForAutomaticProtocol(): void {
        this.update() // emits an event
    }

    onCreateRelationship(): void {
        this.create() // emits an event
    }

    onDeleteRelationship(): void {
        this.delete() // emits an event
    }
}
